import { observable, action } from 'mobx'
import { getUniqueCodeBank, tabIDs } from '../helpers/constants'
import { Request3 } from 'src/common/Request3'
import api from 'src/common/api'
import { isEmpty } from 'lodash'
import { customAlphabet } from 'nanoid'
// import { WsCode } from "../helpers/Wscode";
const designerConfigDefault = {
   timeJob: '',
   amountHold: '',
   rangeDate: '',
   linkSupport: '',
   maxReceive: '',
   minWithdraw: '',
   minRecharge: '',
   rangeJobFinish: ''
}
export class CommonConfigStore {
   @observable listNumberItems: any = {
      results: [{ name: '' }, { name: '' }],
      page: 1,
      limit: 5,
      totalPages: 1,
      totalResults: 1
   }

   @observable linkSupport: string = ''
   @observable activeKeyMain: string = tabIDs.designer
   @observable productTypesList: any = []
   @observable designTypesList: any = []
   @observable exchangeFeeList: any = []
   @observable configList: any = designerConfigDefault
   @observable activeKeyPhiSan: string = this.designTypesList[0]?.id
   @observable bankAccount = {
      BANK_ID: 'TCB',
      ACCOUNT_NO: '330030',
      AMOUNT: '',
      DESCRIPTION: getUniqueCodeBank(), // Tối đa 50 kí tự
      ACCOUNT_NAME: 'PHAM QUANG VINH'
   }
   @action
   resetExchangeFeeList() {
      this.exchangeFeeList = []
   }
   @action
   setExchangeFeeList(value: any) {
      this.resetExchangeFeeList()
      this.exchangeFeeList = [...value]
   }
   @action
   setActiveKeyMain(value: string) {
      this.activeKeyMain = value
   }
   @action
   setActiveKeyPhiSan(value: string) {
      this.activeKeyPhiSan = value
   }
   @action
   resetBankAccount() {
      const nanoBank = customAlphabet('1234567890qwertyuioplkjhgfdsazxcvbnm', 7)
      this.bankAccount = {
         BANK_ID: 'TCB',
         ACCOUNT_NO: '330030',
         AMOUNT: '',
         DESCRIPTION: nanoBank().toUpperCase(), // Tối đa 50 kí tự
         ACCOUNT_NAME: 'PHAM QUANG VINH'
      }
   }

   @action
   async getListSupport() {
      const result = await Request3.get(api.config.getListSupport)
      // console.log('------getListSupport', JSON.stringify(result));
      if (!isEmpty(result?.data?.data)) {
         this.linkSupport = result?.data?.data?.linkSupport
      }
   }

   @action
   async getConfigCommon() {
      const result = await Request3.getWithToken(api.config.getList)
      console.log('))getConfigCommon', result?.data)

      if (!isEmpty(result?.data)) {
         this.configList = { ...result?.data }
         return result?.data
      }
   }

   @action
   async updateConfigCommon(params: any = {}) {
      const result = await Request3.putWithToken(api.config.update, params)
      // console.log('------updateConfigDesigner', JSON.stringify(result));
      // if (!isEmpty(result)) {
      //   this.configList = { ...result };
      // }
      return result
   }

   @action
   async resetStore() {
      // this.listProductType = { ...resultInit };
   }
}
